<template>
   <v-container>
    <v-row>
      <MobileCol>
        <v-alert
          color="primary"
          block
          dark
          dense
          v-for="(item, index) in items"
          :key="index"
        >
          {{ item.heading}}: {{ item.text }}
        </v-alert>
      </MobileCol>
    </v-row>
   </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MobileCol from '../components/MobileCol.vue';

export default {
  name: 'AdminAuth',
  components: {
    MobileCol,
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isExpired']),
    ...mapState('auth', ['token_expires', 'last_token_refresh_request', 'username']),
    items() {
      return [
        {
          heading: 'Username',
          text: this.username,
        },
        {
          heading: 'Token Expires',
          text: this.token_expires,
        },
        {
          heading: 'Is Expired',
          text: this.isExpired,
        },
        {
          heading: 'Is LoggedIn',
          text: this.isLoggedIn,
        },
        {
          heading: 'Last token refresh request',
          text: this.last_token_refresh_request,
        },
      ];
    },
  },
};
</script>
